import React, { FC } from 'react';
import { Grid } from '@mui/material';

import { SubjectPlanningCreateControl } from './SubjectPlanningCreateControl';

export const SubjectControlsGrid: FC<{
    schoolPlanning: { sourceName: string; planningSourceName: string; label: string }[];
}> = ({ schoolPlanning }) => {
    return (
        <Grid container spacing={1} alignItems="center">
            {schoolPlanning.map((planning) => (
                <SubjectPlanningCreateControl
                    key={planning.sourceName}
                    sourceName={planning.planningSourceName}
                    label={planning.label}
                />
            ))}
        </Grid>
    );
};
